<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <!-- Brand -->
    <b-navbar-brand to="/">Hayrat -- YEE</b-navbar-brand>

    <!-- Sidenav toggle -->
    <b-navbar-nav class="align-items-lg-center mr-auto mr-lg-4" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 ml-2 ml-lg-0" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <!-- Navbar toggle -->
    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

<!--    <b-collapse is-nav id="app-layout-navbar">-->
<!--      <b-navbar-nav class="align-items-lg-center">-->
<!--        <b-nav-item href="#">Link 1</b-nav-item>-->
<!--        <b-nav-item href="#">Link 2</b-nav-item>-->
<!--      </b-navbar-nav>-->
<!--    </b-collapse>-->
    <b-navbar-nav class="align-items-lg-center ml-auto">
      <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
        <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <img :src="`${publicUrl}img/avatars/2.png`" alt class="d-block ui-w-30 rounded-circle">
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{name}}</span>
            </span>
        </template>
        <b-dd-item @click="profilim" v-if="yetki === 'Ogrenci'"><i class="ion ion-ios-person text-danger"></i> &nbsp; Profil Düzenle</b-dd-item>
        <b-dd-item @click="cikisYap"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; Çıkış Yap</b-dd-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { getName, getRole } from '@/authentication/jwtParser'
import { removeToken } from '@/utils/auth'

export default {
  name: 'app-layout-navbar',
  data () {
    return {
      name: '',
      yetki: 'Admin'
    }
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    let isim = getName(this.$store.getters.getToken)
    let yetki = getRole(this.$store.getters.getToken)
    this.name = isim
    this.yetki = yetki
  },
  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },
    cikisYap () {
      removeToken('tokenYE')
      location.reload()
    },
    profilim () {
      this.$router.push({ name: 'Profilim' })
    },
    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    }
  }
}
</script>
